import { apiFunction } from "../../apiCall/function"

export const updateDocument = async (data) => {
  return await apiFunction("/form/document", "post", data, true, 'body')
}

export const getDocument = async (data) => {
  return await apiFunction("/form/document", "get", {}, true, 'body')
}